import risksAccordionDictionary from '../../ru/risks-accordion/risks-accordion.dic.json';

export const risksAccordionNS = {
  RISKS_ACCORDION: risksAccordionDictionary,
};

export const risksAccordionNamespaces = ['RISKS_ACCORDION'];
